import { __ } from '@wordpress/i18n';
import clsx from 'clsx';
import { useState, useRef, useEffect } from '@wordpress/element';
import { useSelect,useDispatch} from '@wordpress/data';
import {Modal } from '@wordpress/components';
import { InnerBlocks,store as blockEditorStore} from '@wordpress/block-editor';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import DuotoneFilters from '@vayu-blocks/duotone/DuotoneFilters.js';
import { VideoHtml, MouseFollower } from '@vayu-blocks';
import { VayuBlocksUniqueId } from '@vayu-blocks/global';
import PanelSettings from './advance/inspector-control/index';
import AdvanceSettings from './advance';
import BlockControl from './advance/block-control';
import { getOverlayStyle, getImagePositionStyle, getImageWrapperStyle, getImageStyle, getImageStylecont,
    frame, cancel, iconStylesmain,videoimagestyles } from './advance/inline-style';
import {VariationPicker} from './variation-picker';
import noimagelong from "../../../../inc/assets/img/no-image-long.png";
import VideoUploader from './video-uploader'; 

const edit = ({ attributes, setAttributes, clientId, isSelected}) => {

    const view = VayuBlocksDevice();

    VayuBlocksUniqueId({  setAttributes: setAttributes,  clientId: clientId });

    const [rotation, setRotation] = useState(attributes.rotation);
    const [iconBlocks, setIconBlocks] = useState([]);
    const [videoModalOpen, setVideoModalOpen] = useState(() => {
        return attributes.preview === "preview" ? true : false;
    });

    const imageWrapperRef = useRef(null);
    const overlayWrapperRef = useRef(null);
    const videoRef = useRef(null);
    const overlayRef = useRef(null);

    const parentBlock = useSelect((select) => select('core/block-editor').getBlock(clientId),[clientId]);

    const video_block_template = [
    [
        'vayu-blocks/advance-container',{
                advPosition:{ zIndex:{ "Desktop": 50, "Tablet": 50, "Mobile": 50}}
            },
        [
            ['vayu-blocks/icon', {className: 'vb-icon-block-video',
                advPosition:{
                  zIndex:{
                    "Desktop": 99,
                    "Tablet": 99,
                    "Mobile": 99
                }
                },
            iconName:'play', printedIcon: `<svg  viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="5 3 19 12 5 21 5 3" />
        </svg>`}],
            ],
        ],
    ];
    
    useEffect(() => {
        if (attributes.preview === 'preview') {
            setAttributes({ preview: 'default' });
        }
    }, []);

    useEffect(() => {
        if (attributes.preview === "preview") {
            setVideoModalOpen(false);
        }
    }, [attributes.preview]);
    
    /* 💎 Tilt Effect */
        const tiltEffect = (e) => {
            const wrapper = imageWrapperRef.current;
            if (!wrapper) return;
        
            const rect = wrapper.getBoundingClientRect();
            const x = (e.clientX - rect.left) / rect.width;
            const y = (e.clientY - rect.top) / rect.height;
        
            // Adjust the tilt based on the cursor position
            const tiltX = (y - 0.5) * -4; // Inverted multiplier for the X tilt
            const tiltY = (x - 0.5) * 4; // Regular multiplier for the Y tilt
        
            // Apply the calculated transformation
            wrapper.style.transform = `perspective(500px) rotateX(${tiltX}deg) rotateY(${tiltY}deg)`;
        };
        
        const resetTilt = () => {
            const wrapper = imageWrapperRef.current;
            if (wrapper) {
                wrapper.style.transform = 'perspective(500px) rotateX(0deg) rotateY(0deg)';
            }
        };
        
        useEffect(() => {
            const wrapper = imageWrapperRef.current;
            if (attributes.animationData.effect.animationValue === 'vayu_block_styling-effect7') {
                if (wrapper) {
                    wrapper.addEventListener('mousemove', tiltEffect, { passive: true });
                    wrapper.addEventListener('mouseleave', resetTilt, { passive: true });
                }
            }
            return () => {
                if (wrapper) {
                    wrapper.removeEventListener('mousemove', tiltEffect, { passive: true });
                    wrapper.removeEventListener('mouseleave', resetTilt, { passive: true });
                }
            };
        }, [attributes.animationData.effect.animationValue]);
        
        const overlaytiltEffect = (e) => {
            const wrapper = overlayWrapperRef.current;
            if (!wrapper) return;
        
            const rect = wrapper.getBoundingClientRect();
            const x = (e.clientX - rect.left) / rect.width;
            const y = (e.clientY - rect.top) / rect.height;
        
            // Adjust the tilt based on the cursor position
            const tiltX = (y - 0.5) * -6; // Inverted multiplier for the X tilt
            const tiltY = (x - 0.5) * 6; // Regular multiplier for the Y tilt
        
            // Apply the calculated transformation
            wrapper.style.transform = `perspective(500px) rotateX(${tiltX}deg) rotateY(${tiltY}deg)`;
        };
        
        const overlayresetTilt = () => {
            const wrapper = overlayWrapperRef.current;
            if (wrapper) {
                wrapper.style.transform = 'perspective(500px) rotateX(0deg) rotateY(0deg)';
            }
        };
        
        useEffect(() => {
            const wrapper = overlayWrapperRef.current;
            if (attributes.animationData.effect.animationValue === 'vayu_block_styling-effect7') {
                if (wrapper) {
                    wrapper.addEventListener('mousemove', overlaytiltEffect, { passive: true });
                    wrapper.addEventListener('mouseleave', overlayresetTilt, { passive: true });
                }
            }
            return () => {
                if (wrapper) {
                    wrapper.removeEventListener('mousemove', overlaytiltEffect, { passive: true });
                    wrapper.removeEventListener('mouseleave', overlayresetTilt, { passive: true });
                }
            };
        }, [attributes.animationData.effect.animationValue]);

    /* 💎 video Src Maker */

        const queryParams = [
            attributes.youautoplay ? 'autoplay=1' : 'autoplay=0',
            attributes.youtubemuted ? 'mute=1' : 'mute=0',
            attributes.youcontrols ? 'controls=0' : '',
            attributes.youloop ? `loop=1&playlist=${attributes.youvideoUrl}` : '',
            attributes.startTime ? `start=${attributes.startTime}` : '',
            attributes.endTime ? `end=${attributes.endTime}` : '',
            attributes.rel === true ? 'rel=1' : 'rel=0',
        ].filter(Boolean).join('&');

        const src = `https://www.youtube.com/embed/${attributes.youvideoUrl}?${queryParams}`;

        const queryParamsmod = [
            'autoplay=1',
            attributes.youtubemuted ? 'mute=1' : 'mute=0',
            attributes.youcontrols ? 'controls=0' : '',
            attributes.youloop ? `loop=1&playlist=${attributes.youvideoUrl}` : '',
            attributes.startTime ? `start=${attributes.startTime}` : '',
            attributes.endTime ? `end=${attributes.endTime}` : '',
            attributes.rel === true ? 'rel=1' : 'rel=0',
        ].filter(Boolean).join('&');

        const modsrc = `https://www.youtube.com/embed/${attributes.youvideoUrl}?${queryParamsmod}`;

        const vimeoQueryParams = [
            ...(attributes.vimeoautoplay ? ['autoplay=1', 'muted=1'] : []),
            ...(!attributes.vimeoautoplay && attributes.vimeomuted ? ['muted=1'] : []),
            ...(attributes.vimeoloop ? ['loop=1'] : []),
            ...(attributes.vimeocontrols === false ? ['controls=0'] : []),
            ...(attributes.vimeobackground ? ['background=1'] : []),
        ].join('&');
        
        const vimeoSrc = attributes.vimeourl 
            ? `https://player.vimeo.com/video/${attributes.vimeourl}${vimeoQueryParams ? '?' + vimeoQueryParams : ''}` 
            : '';

        const vimeoQueryParamsmod = [
            'autoplay=1',
            ...(!attributes.vimeoautoplay && attributes.vimeomuted ? ['muted=1'] : []),
            ...(attributes.vimeoloop ? ['loop=1'] : []),
            ...(attributes.vimeocontrols === false ? ['controls=0'] : []),
            ...(attributes.vimeobackground ? ['background=1'] : []),
        ].join('&');
        
        const vimeoSrcmod = attributes.vimeourl 
            ? `https://player.vimeo.com/video/${attributes.vimeourl}${vimeoQueryParamsmod ? '?' + vimeoQueryParams : ''}` 
            : '';

    /* 💎 Video icon and poster making with modal open or close */  
        const { getBlockOrder, getBlock } = useSelect(select => select(blockEditorStore), []);
        const { removeBlock } = useDispatch(blockEditorStore);

        useEffect(() => {
            const innerBlockIds = getBlockOrder(clientId); // get inner block ids
            if (!attributes.posterOn && innerBlockIds.length > 0) {
                innerBlockIds.forEach(id => removeBlock(id));
            }
        }, [attributes.posterOn]);

        const getIcons = (block) =>
            block?.innerBlocks?.flatMap((b) =>
            b.name === 'vayu-blocks/icon'
                ? [{ clientId: b.clientId, id: b.attributes?.id }].concat(getIcons(b)): getIcons(b)
        ) || [];

        useEffect(() => {
            if (parentBlock) {
            const icons = getIcons(parentBlock);
            setIconBlocks(icons);
            }
        }, [parentBlock]);

        useEffect(() => {
            const container = imageWrapperRef.current;
            if (!container) return;

            // Delegated click handler, check if click was on a block with data-block attribute
            function handleClick(event) {
            const blockDiv = event.target.closest('[data-block]');
            if (!blockDiv) return;

            const clickedClientId = blockDiv.getAttribute('data-block');
            if (!clickedClientId) return;

            // Optional: Check if clickedClientId is in our iconBlocks list to confirm
            const isIconBlock = iconBlocks.some(b => b.clientId === clickedClientId);
            if (!isIconBlock) return;

            // Your logic on click:
            setVideoModalOpen(true);
            setAttributes({ preview: 'default' });

            }

            container.addEventListener('click', handleClick);

            return () => {
            container.removeEventListener('click', handleClick);
            };
        }, [iconBlocks, setAttributes, setVideoModalOpen]);   
        
    /* 💎 Style */
        const overlayStyle = getOverlayStyle(attributes, view);  

        const vayu_blocks_image_position = getImagePositionStyle(attributes, view);

        const vayu_blocks_image_wrapper_style = getImageWrapperStyle(attributes,view);

        const vayu_blocks_image_settings = getImageStyle(attributes, view);

        const framestyles = frame(attributes, view);

        const iconStylemain =  iconStylesmain(attributes,view);

        const cancelstyles = cancel(attributes, view);

        const framestylescont = getImageStylecont(attributes, view);

        const videoimagestyle = videoimagestyles(attributes,view);

        const rotateImage = () => {
            const newRotation = (rotation + 90);
            setRotation(newRotation); setAttributes({ rotation: newRotation });
        };

        const camelToKebab = (str) => str.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase());

        const formatCancelStylesAsVars = (cancelStyles) => {
            const cssVars = {};
            for (const state in cancelStyles) {
                const styleObj = cancelStyles[state];
                for (const key in styleObj) {
                    const cssVarName = `--vayu-cancel-${state}-${camelToKebab(key)}`;
                    cssVars[cssVarName] = styleObj[key];
                }
            }
            return cssVars;
        };

        const cancelCSSVars = formatCancelStylesAsVars(cancelstyles);

        useEffect(() => {
            const modalColor = attributes?.lightboxcolor;
            const overlay = overlayRef.current;

            if (!overlay) return;

            const applyStyle = () => {
                overlay.style.background = modalColor;

                // Apply cancel CSS vars
                if (cancelCSSVars && typeof cancelCSSVars === 'object') {
                    Object.entries(cancelCSSVars).forEach(([key, value]) => {
                        overlay.style.setProperty(key, value);
                    });
                }
            };

            applyStyle();

            const observer = new MutationObserver(() => {
                applyStyle();
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });

            return () => observer.disconnect();
        }, [attributes?.lightboxcolor, cancelCSSVars]);

    /* 💎 Class */
        const getclassoverlay = () => {
            const value = attributes.animationData?.imageAnimation?.animationValue;
            const hoverType = attributes.animationData?.imageAnimation?.hover;
        
            if (!value) return '';
        
            if (hoverType === 'with-hvr') {
                return `${value}hvr`;
            } else if (hoverType === 'one-time') {
                return `${value}onetime`;
            } else {
                return `${value}`;
            }
        };

        const safeClass = (cls) => (cls && cls !== 'none' ? cls : '');

        const blockClass = clsx(
            safeClass(attributes?.animationData?.effect?.animationValue),
            attributes?.contentani && 'vb-start-cont-ani'
        );

        const wrapperClass = clsx(
            'vb-video-animation-container',
            safeClass(attributes.animationData?.hovereffect?.value),
            safeClass(getclassoverlay())
        );

        const maskClass = attributes.animationData?.mask?.maskshape === 'none'
        ? ''
        : 'maskshapeimage';

        const lighboxvideotag = clsx(
            'vb-video-iframe-tag',
            safeClass(maskClass)
        );

        const videoClass = clsx(
            'vb-video-iframe-tag',
            'vb-you-tube-tag',
            safeClass(maskClass)
        );

        const videoiframeClass = clsx(
            'vb-video-iframe-tag',
            safeClass(maskClass)
        );

    return (
        <>

            {isSelected && (
                <BlockControl  attributes={attributes} setAttributes={setAttributes} rotateImage={rotateImage}/>
            )}
           
            <PanelSettings attributes={attributes} setAttributes={setAttributes} isSelected={isSelected} clientId={clientId}/>
            <AdvanceSettings attributes={attributes} setAttributes={setAttributes} framestyles={framestyles}>
            <VideoHtml bg={attributes.advBackground} />
            
                {attributes.blockValue ? (
				<>
                    <div ref={imageWrapperRef} className="vayu-blocks-video-blcoks" >
                        <div className={blockClass} style={vayu_blocks_image_position}>

                            {Array.isArray(attributes.duotone) && attributes.duotone.length > 1 && (
                                <div className='vb-video-duotone'> 
                                    <DuotoneFilters duotone={attributes.duotone} uniqueId={attributes.uniqueId} />
                                </div>
                            )}

                            {(attributes.image || attributes.videoUrl || attributes.youvideoUrl ||  attributes.vimeourl) && (
                            
                                <div className="vb-video-container" style={vayu_blocks_image_wrapper_style} >
                                    <div style={{transform:`rotate(${attributes.rotation}deg)`}}>
                                        <div className={wrapperClass}>
                                            <>
                                                {((attributes.blockValue ==='mp4' && attributes.videoUrl && attributes.videoUrl.length > 1)|| (attributes.blockValue === 'you-tube' && attributes.youvideoUrl && attributes.youvideoUrl.length > 1) || attributes.blockValue === 'vimeo' && attributes.vimeourl && attributes.vimeourl.length > 1) && (
                                                    <>
                                                        {attributes.posterOn && (
                                                           (attributes.lightbox === true || !videoModalOpen) && (
                                                                <>
                                                                    <div style={overlayStyle} className='vb-video-poster'>
                                                                        <img 
                                                                            src={attributes.poimage || noimagelong} 
                                                                            className="vb-video-tag-image" 
                                                                            style={{...videoimagestyle,...vayu_blocks_image_settings, display: 'block', objectPosition: `${(attributes.pofocalPoint?.x ?? 0.5) * 100}% ${(attributes.pofocalPoint?.y ?? 0.5) * 100}%`}}
                                                                        />
                                                                    </div>

                                                                    <div style={iconStylemain} className="vb-video-icon">
                                                                        <InnerBlocks
                                                                            template={video_block_template}
                                                                            templateLock={false}
                                                                        />
                                                                    </div>
                                                                </>
                                                            )
                                                        )}
                                                    </>
                                                )}

                                                {!attributes.lightbox && (
                                                <>
                                                    {(attributes.posterOn ? videoModalOpen : true) && (
                                                        <>
                                                            {attributes.blockValue ==='mp4' && attributes.videoUrl && attributes.videoUrl.length > 1 &&(
                                                                <>
                                                                    <video 
                                                                        key={attributes.videoUrl}
                                                                        className={lighboxvideotag}   
                                                                        autoPlay={attributes.posterOn === true}
                                                                        loop={attributes.loop}
                                                                        ref={videoRef}
                                                                        controls={attributes.controls}
                                                                        muted={attributes.muted}
                                                                        poster={attributes.fallbackImageUrl}
                                                                        controlsList={`
                                                                            ${attributes.nofullscreen ? 'nofullscreen' : ''}
                                                                            ${attributes.nodownload ? 'nodownload' : ''}
                                                                            ${attributes.noremoteplayback ? 'noremoteplayback' : ''}
                                                                            ${attributes.noplaybackrate ? 'noplaybackrate' : ''}
                                                                        `.trim()}
                                                                        style={{...vayu_blocks_image_settings, ...videoimagestyle}}
                                                                    >
                                                                        <source src={attributes.videoUrl} type="video/mp4" />
                                                                        Your browser does not support the video tag.
                                                                    </video>

                                                                </>
                                                            )}

                                                            {attributes.blockValue === 'you-tube' && attributes.youvideoUrl && attributes.youvideoUrl.length > 1 && (
                                                            
                                                            <div className="vb-video-iframe-cont" style={framestylescont}>
                                                                <iframe
                                                                    key={`${attributes.youvideoUrl}-${attributes.youtubefullscreen}-${attributes.youautoplay}-${attributes.youtubemuted}`}
                                                                        loading='lazy'
                                                                    style={vayu_blocks_image_settings}
                                                                    className={videoClass}
                                                                    src={src}
                                                                    title="YouTube video player"
                                                                    frameborder="0"
                                                                    referrerpolicy="strict-origin-when-cross-origin"
                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                    {...(attributes.youtubefullscreen ? { allowFullScreen: true } : {})}
                                                                />
                                                            </div>

                                                            )}

                                                            {attributes.blockValue === 'vimeo' && attributes.vimeourl && attributes.vimeourl.length > 1 && (
                                                                <iframe
                                                                    key={`${attributes.vimeofullscreen}`}
                                                                    loading='lazy'
                                                                    style={{...vayu_blocks_image_settings, ...videoimagestyle}}
                                                                    className={videoiframeClass}
                                                                    src={vimeoSrc}
                                                                    title="Vimeo video player"
                                                                    frameborder="0"
                                                                    {...(attributes.vimeofullscreen ? { allowFullScreen: true } : {})}
                                                                    referrerpolicy="strict-origin-when-cross-origin"
                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                                )}
                                            </>
                                        </div>  
                                    </div>    
                                </div>
                        
                            )}

                        </div>

                        {(attributes.lightbox && videoModalOpen) && (
                            <>
                                <Modal
                                   onRequestClose={() => {
                                        setVideoModalOpen(false);
                                        setAttributes({ preview: 'default' });
                                    }}
                                    shouldCloseOnClickOutside={true}
                                    __experimentalHideHeader={true}
                                    bodyOpenClassName="vb-model-video-open"
                                    overlayClassName="vb-model-video-open-overlay"
                                    size='large'
                                    style={{transition: 'all 0.5s ease', background:attributes.videoboxcolor}}
                                    ref={overlayRef}
                                >
                                    <span className="vb-video-close-button" onClick={() => {setVideoModalOpen(false); setAttributes({ preview: 'default' }); }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" role="img" aria-hidden="true" focusable="false">
                                            <path d="M 6.225 4.811 L 4.811 6.225 L 10.586 12 L 4.811 17.775 L 6.225 19.189 L 12 13.414 L 17.775 19.189 L 19.189 17.775 L 13.414 12 L 19.189 6.225 L 17.775 4.811 L 12 10.586 Z"></path>
                                        </svg>
                                    </span>

                                    <div style={{ width: '100%', height: '100%' }}>
                                        <>
                                            {attributes.blockValue ==='mp4' && attributes.videoUrl && attributes.videoUrl.length > 1 &&(
                                                <>
                                                    <video 
                                                        key={attributes.videoUrl}
                                                        className={videoiframeClass}   
                                                        autoPlay={true}
                                                        loop={attributes.loop}
                                                        ref={videoRef}
                                                        controls={attributes.controls}
                                                        muted={attributes.muted}
                                                        poster={attributes.fallbackImageUrl}
                                                        controlsList={`
                                                            ${attributes.nofullscreen ? 'nofullscreen' : ''}
                                                            ${attributes.nodownload ? 'nodownload' : ''}
                                                            ${attributes.noremoteplayback ? 'noremoteplayback' : ''}
                                                            ${attributes.noplaybackrate ? 'noplaybackrate' : ''}
                                                        `.trim()}
                                                    >
                                                        <source src={attributes.videoUrl} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>

                                                </>
                                            )}

                                            {attributes.blockValue === 'you-tube' && attributes.youvideoUrl && attributes.youvideoUrl.length > 1 && (
                                            
                                                <iframe
                                                    key={`${attributes.youvideoUrl}-${attributes.youtubefullscreen}-${attributes.youautoplay}-${attributes.youtubemuted}`}
                                                        loading='lazy'
                                                    className={videoiframeClass}
                                                    src={modsrc}
                                                    title="YouTube video player"
                                                    frameborder="0"
                                                    referrerpolicy="strict-origin-when-cross-origin"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    {...(attributes.youtubefullscreen ? { allowFullScreen: true } : {})}
                                                />

                                            )}

                                            {attributes.blockValue === 'vimeo' && attributes.vimeourl && attributes.vimeourl.length > 1 && (

                                                <iframe
                                                    key={`${attributes.vimeofullscreen}`}
                                                    loading='lazy'
                                                    className={videoiframeClass}
                                                    src={vimeoSrcmod}
                                                    title="Vimeo video player"
                                                    frameborder="0"
                                                    {...(attributes.vimeofullscreen ? { allowFullScreen: true } : {})}
                                                    referrerpolicy="strict-origin-when-cross-origin"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    
                                                />

                                            )}
                                        </>
                                    </div>
                                </Modal>
                            
                            </>
                        )}

                        <MouseFollower value={attributes.advFollower} clientId={clientId}/>
                        <VideoUploader attributes={attributes} setAttributes={setAttributes}/>
                    </div>
            	</>
				):(
                    <VariationPicker
                        onChange={(value)=>setAttributes({blockValue:value})}
                    />
                )}
                
            </AdvanceSettings>
        </>
    );
};

export default edit;